<template>
    {{normalFormat(dateTime)}}
</template>

<script>
export default {
    data() {
        return {
            dateTime: 0
        }
    },
    props: {
        modelValue: {
            required: true,
        },
        onlyDate: {
            default: false
        }
    },
    created() {
        this.dateTime = new Date(Date.parse(this.modelValue))
    },
    watch: {
        modelValue: function() {
            this.dateTime = new Date(Date.parse(this.modelValue))
        }
    },
    methods: {
        normalFormat() {
            const hours = this.dateTime.getHours().toString().padStart(2, '0');
            const minutes = this.dateTime.getMinutes().toString().padStart(2, '0');
            const timeString = hours + ':' + minutes;
            const formatter = new Intl.DateTimeFormat('en-US', {
                // weekday: 'long',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                // hour: 'numeric',
                // minute: 'numeric',
                // second: 'numeric',
                // timeZoneName: 'short'
            })

            if (this.onlyDate)
                return formatter.format(this.dateTime)
            return timeString + ', ' + formatter.format(this.dateTime) 
        }
    }
}
</script>
